<template>
  <modal
    :visible="$city.data.isCityModalShown"
    allow-close
    @on-close="$city.emmiter.emit('city:close')"
  >
    <city-search
      @choose="change"
    />
  </modal>
</template>

<script>
import CitySearch from '@/components/header/city-search.vue';

export default {
  components: {
    CitySearch,
  },

  methods: {
    change(city) {
      this.$city.emmiter.emit('city', city);
    },
  },
};
</script>
